import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const servicesPost = createAsyncThunk(
  'services/fetchServices',
  async (userData, thunkAPI) => {
    const BASE_URL = 'https://dreamonelove.com';
    const END_POINT = '/gloriabrides/services/servicesAPI';
    const url = BASE_URL + END_POINT;
    const servicesData = {
      cmd: 'CMD_GET_SERVICES',
    };

    try {
      const response = await axios.post(url, servicesData);
      return response.data.result.serviceList;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const getServiceData = createAsyncThunk(
  'services/getServiceData',
  async (id, thunkAPI) => {
    const BASE_URL = 'https://dreamonelove.com';
    const END_POINT = '/gloriabrides/services/servicesAPI';
    const url = BASE_URL + END_POINT;
    const servicesData = {
      cmd: 'CMD_GET_SERVICE',
      serviceId: id,
    };

    try {
      const response = await axios.post(url, servicesData);
      return response.data.result;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
